module.exports = __webpack_public_path__ + "static/media/glyphicons-halflings-regular.f7214668.svg";